import React from 'react';

const DescripcionViguetaWpc = () => {
  const datosTecnicos = [
    { label: 'Medidas', value: '2.9 m x 9 cm' },
    { label: 'Espesor', value: '4 cm' },
    { label: 'Área por pieza', value: '0.0261 m²' },
    { label: 'Material', value: 'WPC Coextruido' },
    { label: 'Filtro UV', value: 'Sí' },
    { label: 'Uso', value: 'Exterior' },
  ];

  const colores = [
    { name: 'Nogal (VIG016-07B)', color: '#8b5e3c' },
    { name: 'Teka (VIG025-01B)', color: '#7c5c3d' },
  ];

  const features = [
    {
      imgSrc: '/assets/img/icons/icon-flecha-derecha.png',
      titulo: 'Resistencia a la Intemperie',
      descripcion:
        'Diseñada para soportar las condiciones climáticas más exigentes, la vigueta WPC no se deforma, agrieta ni pierde su apariencia con el paso del tiempo.',
    },
    {
      imgSrc: '/assets/img/icons/icon-flecha-derecha.png',
      titulo: 'Durabilidad Extrema',
      descripcion:
        'Su composición única asegura una larga vida útil, superando ampliamente a los materiales tradicionales.',
    },
    {
      imgSrc: '/assets/img/icons/icon-flecha-derecha.png',
      titulo: 'Bajo Mantenimiento',
      descripcion:
        'A diferencia de la madera, no requiere barniz, pintura ni tratamientos regulares. Su limpieza es sencilla y rápida.',
    },
    {
      imgSrc: '/assets/img/icons/icon-flecha-derecha.png',
      titulo: 'Estética Natural',
      descripcion:
        'Con acabados que imitan a la perfección la textura y el color de la madera, es perfecta para proyectos que buscan un diseño cálido y sofisticado.',
    },
  ];

  return (
    <>
      {/* SECCIÓN 1: Imagen (izq) + Encabezado, texto y cards de datos (der) */}
      <section>
        <div className="container">
          <div className="row g-xxl-5 align-items-start">
            {/* Columna izquierda: imagen */}
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="d-flex justify-content-center justify-content-lg-start">
                <img
                  src="/assets/img/productos/vigueta-wpc/vigueta-wpc-descripcion-2a.jpg"
                  alt="vigueta wpc descripcion"
                  className="img-fluid rounded"
                  style={{ width: '100%', maxWidth: '500px', aspectRatio: '1 / 1', objectFit: 'cover' }}
                />
              </div>
            </div>

            {/* Columna derecha: encabezado, texto y cards */}
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="ps-lg-1-6 ps-xl-6">
                <div className="title-style1 mb-3">
                  <span>Entrega Inmediata</span>
                  <h2 className="h1 mb-4">Características Destacadas de la Vigueta WPC</h2>
                  <p className="mb-3">
                    Elegir la vigueta WPC de Decototal significa optar por un material que combina
                    la belleza de la madera con las ventajas de la tecnología moderna. Ya sea para
                    proyectos residenciales, comerciales o industriales, esta solución garantiza
                    resultados duraderos, estéticos y sostenibles.
                  </p>
                </div>

                <div className="bg-white rounded shadow-sm border p-4 p-lg-5 mb-3 w-100">
                  <h3 className="h5 mb-3">Datos técnicos</h3>
                  <ul className="list-unstyled mb-0">
                    {datosTecnicos.map((item) => (
                      <li
                        key={item.label}
                        className="d-flex justify-content-between py-2 border-bottom"
                      >
                        <span className="text-muted">{item.label}</span>
                        <strong className="text-dark">{item.value}</strong>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded shadow-sm border p-4 p-lg-5 w-100">
                  <h3 className="h5 mb-3">Colores disponibles</h3>
                  <ul className="list-unstyled mb-0">
                    {colores.map((color) => (
                      <li key={color.name} className="d-flex align-items-center mb-2">
                        <span
                          className="d-inline-block rounded-circle me-2"
                          style={{ width: '14px', height: '14px', backgroundColor: color.color }}
                          aria-hidden="true"
                        ></span>
                        <span>{color.name}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 2: Cards con iconos, 2 por fila en escritorio */}
      <section>
        <div className="container">
          <div className="row g-xxl-5 mt-3">
            {features.map((feature) => (
              <div className="col-lg-6" key={feature.titulo}>
                <FeatureItem
                  imgSrc={feature.imgSrc}
                  titulo={feature.titulo}
                  descripcion={feature.descripcion}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

const FeatureItem = ({ imgSrc, titulo, descripcion }) => {
  return (
    <div className="d-flex border-bottom pb-1-6 mb-1-6 h-100">
      <div className="flex-shrink-0 me-4">
        <img src={imgSrc} alt={titulo} />
      </div>
      <div className="flex-grow-1">
        <h4 className="h5">{titulo}</h4>
        <p className="mb-0">{descripcion}</p>
      </div>
    </div>
  );
};

export default DescripcionViguetaWpc;